// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7642) return "static/chunks/94a7ad86-b7ab0ab0682c5e3a.js";
	if (chunkId === 3540) return "static/chunks/3540-16b7eabccf5f4423.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1915":"a8e3d9c0","2825":"29d08900","8688":"3e93f04a"}[chunkId] || chunkId) + "." + {"1219":"18cb3a0a979a6a1b","1915":"6c01d9baf4e86843","2825":"f7acae188c97f7a4","2854":"2bc50eb47e054502","8688":"fa993136bc1c7e4d","8961":"53268346b48b2818","9094":"6099a9bad3d4c699"}[chunkId] + ".js";
};